module.exports = __webpack_public_path__ + "static/media/gymet_3.b9e7806e.png";